/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface QuestionnaireAnswer {
  readonly id: string;
  readonly number: number;
  readonly text: string;
  readonly expect_custom_answer: boolean;
  readonly valid: boolean;
}
